var React = require('react');

function MedCross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M43.758 134.962c-.454-.277-.96-.89-1.125-1.361-.212-.608-.299-6.408-.299-19.849v-18.99l-.814-.814-.814-.814H21.668c-15.856 0-19.189-.063-19.938-.376-1.82-.76-1.73.533-1.73-25.024C0 42.177-.088 43.47 1.73 42.71c.75-.313 4.082-.376 19.938-.376h19.038l.814-.814.814-.814V21.668c0-15.856.063-19.189.376-19.938C43.47-.09 42.177 0 67.734 0c25.557 0 24.264-.089 25.024 1.73.313.75.376 4.082.376 19.938v19.038l.814.814.814.814H113.8c15.856 0 19.189.063 19.939.376 1.818.76 1.728-.533 1.728 25.024 0 25.557.09 24.264-1.728 25.024-.75.313-4.083.376-19.939.376H94.762l-.814.814-.814.814V113.8c0 15.856-.063 19.189-.376 19.939-.76 1.818.54 1.728-25.077 1.727-22.235 0-23.129-.02-23.923-.504z","fill":"currentColor"}));
}

MedCross.defaultProps = {"viewBox":"0 0 135.468 135.467"};

module.exports = MedCross;

MedCross.default = MedCross;
